module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "file_015"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0010-01.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "file_015"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_vm._v("This rare image shows Grumman’s first facility in Baldwin, New York. Rumor has it that Grumman Aircraft Engineering didn’t really have a sign most of the time. It was hastily assembled by the shop men especially for the photo. "), _c('em', [_vm._v("Grumman History Center")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b94f06f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/file_015.vue
// module id = 96
// module chunks = 0